import { Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';

import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Credentials } from '../models/credentials.model';
import { StompService } from './stomp/stomp.service';
import { NotifierService } from './notifier.service';
import { Observable, Subscription } from 'rxjs';
import { ConfigurationFormulaireConnexionDto } from '../models/configuration-formulaire-connexion.dto';

@Injectable()
export class ConnectService {

	private httpBackend: HttpClient;
	constructor(httpBackend: HttpBackend, private http: HttpClient, private router: Router, @Optional() private notifierService: NotifierService, @Optional() private stompService: StompService) {
		this.httpBackend = new HttpClient(httpBackend);
	}

	/**
	 * Récupère la configuration pour le formulaire de connexion.
	 */
	recupererConfigurationPourFormulaireConnexion(): Observable<ConfigurationFormulaireConnexionDto> {
		// passage par le httpbackend afin de ne pas inclure le token d'authentification dans la requête, dans le cas contraire, le token va être vérifié et si expiré, la requête va échouer
		return this.httpBackend.get<ConfigurationFormulaireConnexionDto>('/ws/formulaire-connexion/configuration');
	}

	/**
	 * Connecte l'utilisateur et redirige vers la page d'accueil
	 * @param authDetail
	 * @param erreurCallBack
	 */
	login(authDetail: Credentials, erreurCallBack: (erreur: any) => void): Subscription {
		return this.http.post('ws/auth', authDetail, { observe: 'response', responseType: 'text' })
			.subscribe({
				next: () => this.router.navigate(['/']),
				error: (erreur) => erreurCallBack(erreur)
			});
	}

	/**
	 * Rafraîchit le token de l'utilisateur (sans revenir sur la page d'accueil après connexion)
	 *
	 * @param authDetail les données d'authentification.
	 * @param succesCallBack le callback appelé en cas de rafraichissement de token.
	 * @param erreurCallBack le callback appelé en cas d'erreur de rafraichissement de token.
	 */
	rafraichirToken(authDetail: Credentials, succesCallBack: (data: any, status: any, headers: HttpHeaders) => void, erreurCallBack: (erreur: any) => void): void {
		this.http.post('ws/auth', authDetail, { observe: 'response', responseType: 'text' })
			.subscribe({
				next: (response) => succesCallBack(response.body, response.status, response.headers),
				error: (erreur) => erreurCallBack(erreur)
			});
	}

	/**
	 * Déconnecte l'utilisateur et redirige vers la page de connexion.
	 */
	logout() {
		this.http.post('ws/logout', {}).toPromise().then(
			this._logout.bind(this), this._logout.bind(this)
		).catch(this._logout.bind(this));
	}

	/**
	 * Déconnecte l'utilisateur sans rediriger vers la page de connexion.
	 */
	logoutSansRedirection(): void {
		this.http.post('ws/logout', {}).subscribe();
	}

	private _logout() {
		if (this.stompService) {
			this.stompService.desactiver();
		}
		else if (this.notifierService) {
			this.notifierService.disconnectFromAll();
		}
		this.supprimerTokenAuthentification();
		this.router.navigate(['/login']);
	}

	/**
	 * Supprime le token d'authentification de l'utilisateur.
	 */
	supprimerTokenAuthentification() {
		localStorage.removeItem('access_token');
	}

	/**
	 * Récupère le token d'authentification de l'utilisateur.
	 */
	getToken() {
		return localStorage.getItem('access_token');
	}
}
